<template>
        <v-container fluid class="container--fluid">
          <v-row justify="center">
            <v-col cols="12">
              <h1 class="text-center">
                {{currentUser.roleId === 1 || currentUser.roleId === 2 ? 'Přidat do jídelníčku' : 'Obsah jídelníčku'}}
              </h1>
            </v-col>
            <v-form
              ref="form"
              v-model="formValid"
            >
              <v-row class="col-12">
                <v-col cols="6">
                  <v-menu
                    ref="calendar"
                    v-model="pickCalendar"
                    close-on-content-click
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.date"
                        label="Datum"
                        hint="formát RRRR-MM-DD"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        outlined
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.date"
                      no-title
                      :max="diet.dateTo"
                      :min="diet.dateFrom"
                      locale="cs-cz"
                      first-day-of-week="1"
                      :title-date-format="date=>new Date(date).toLocaleDateString('cs-cz')"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-select
                    color="green"
                    label="Vyberte typ stravy"
                    prepend-icon="mdi-format-list-bulleted"
                    v-model="form.foodTypes"
                    :rules="[rules.required]"
                    :items="availableFoodTypes"
                    :search-input.sync="search"
                    item-value="id"
                    item-text="name"
                    hide-selected
                    multiple
                    persistent-hint
                    small-chips
                    outlined
                    deletable-chips
                    return-object
                    v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    color="green"
                    label="Vyberte denní dobu"
                    prepend-icon="mdi-clock-time-eight-outline"
                    v-model="form.timeType"
                    :rules="[rules.required]"
                    :items="timeTypes"
                    item-value="id"
                    item-text="name"
                    persistent-hint
                    outlined
                    deletable-chips
                    return-object
                    v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    color="green"
                    label="Pití"
                    prepend-icon="mdi-cup"
                    v-model="form.drinks"
                    :items="filteredDrinks"
                    item-text="internalName"
                    return-object
                    :search-input.sync="search"
                    ref="drinksInput"
                    hide-selected
                    multiple
                    persistent-hint
                    small-chips
                    deletable-chips
                    outlined
                    :disabled="itemSelectDisabled"
                    v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    color="green"
                    label="Jídla"
                    prepend-icon="mdi-food-fork-drink"
                    v-model="form.foods"
                    :items="filteredFoods"
                    return-object
                    item-text="internalName"
                    :search-input.sync="search"
                    ref="foodsInput"
                    hide-selected
                    multiple
                    persistent-hint
                    small-chips
                    deletable-chips
                    outlined
                    :disabled="itemSelectDisabled"
                    v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    color="green"
                    label="Menu"
                    prepend-icon="mdi-silverware"
                    v-model="form.menus"
                    :items="filteredMenus"
                    item-text="internalName"
                    ref="menusInput"
                    return-object
                    :search-input.sync="search"
                    hide-selected
                    multiple
                    persistent-hint
                    small-chips
                    deletable-chips
                    outlined
                    :disabled="itemSelectDisabled"
                    v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="green"
                    v-model="price"
                    prepend-icon="mdi-cash"
                    label="Cena"
                    disabled
                    outlined
                    required
                    v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="green"
                    :value="itemsAlergens"
                    label="Alergeny"
                    prepend-icon="mdi-pill"
                    disabled
                    outlined
                    required
                    v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="green"
                    :value="weight"
                    prepend-icon="mdi-weight-gram"
                    disabled
                    outlined
                    label="Gramáž"
                    v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="green"
                    :value="volume"
                    disabled
                    label="Objem"
                    outlined
                    prepend-icon="mdi-cup-water"
                    v-if="currentUser.roleId === 1 || currentUser.roleId === 2">
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="green"
                    :value="calories"
                    label="Kalorie"
                    prepend-icon="mdi-food"
                    disabled
                    outlined
                    required
                    v-if="currentUser.roleId === 1 || currentUser.roleId === 2">
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    type="number"
                    min="1"
                    color="green"
                    label="Priorita zápisu"
                    prepend-icon="mdi-priority-high"
                    v-model="form.menu_sequence"
                    item-text="priority"
                    persistent-hint
                    outlined
                    v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="6"
                  v-if="currentUser.roleId === 1 || currentUser.roleId === 2">
                  <v-checkbox
                    ref="dataChecked"
                    v-model="dataChecked"
                    :rules="[rules.checked]"
                    label="Data jsou zkontrolována"
                    outlined
                    required>
                  </v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  class="text-right"
                  v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
                >
                  <v-btn
                    :disabled="!(formValid && itemSelected)"
                    color="warning"
                    class="mr-4"
                    @click="save"
                  >
                    Přidat do jídelníčku
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-row>
        </v-container>
</template>

<script>
import rules from '../../../mixins/rules'
import { mapGetters } from 'vuex'

export default {
  name: 'AddToDietForm',
  mixins: [rules],
  props: ['dietDayId', 'diet'],
  data () {
    return {
      pickCalendar: false,
      dialog: false,
      search: null,
      availableFoods: [],
      availableDrinks: [],
      availableMenus: [],
      availableFoodTypes: [],
      availableAlergens: [],
      timeTypes: [],
      form: {
        menu_sequence: 1,
        date: null,
        price: '',
        photo: null,
        foodTypes: [],
        timeType: null,
        foods: [],
        drinks: [],
        menus: [],
        timeId: null
      },
      formValid: true,
      dataChecked: false
    }
  },
  computed: {
    itemSelected () {
      return this.form.foods.length || this.form.drinks.length || this.form.menus.length
    },
    itemSelectDisabled () {
      return !(this.form.timeType && !!this.form.foodTypes.length)
    },
    filteredFoods () {
      if (this.itemSelectDisabled) {
        return []
      }
      return this.availableFoods.filter(food => {
        const containsTimeType = food.timeTypes
          .map(tt => tt.id)
          .includes(this.form.timeType.id)
        const containsFoodTypes = food.foodTypes.some(type => {
          const formFoodTypesIds = this.form.foodTypes.map(ft => ft.id)
          return formFoodTypesIds.includes(type.id)
        })
        return containsTimeType && containsFoodTypes
      })
    },
    filteredDrinks () {
      if (this.itemSelectDisabled) {
        return []
      }
      return this.availableDrinks.filter(drink => {
        const containsTimeType = drink.timeTypes
          .map(tt => tt.id)
          .includes(this.form.timeType.id)
        const containsFoodTypes = drink.foodTypes.some(type => {
          const formFoodTypesIds = this.form.foodTypes.map(ft => ft.id)
          return formFoodTypesIds.includes(type.id)
        })
        return containsTimeType && containsFoodTypes
      })
    },
    filteredMenus () {
      if (this.itemSelectDisabled) {
        return []
      }
      return this.availableMenus.filter(menu => {
        const containsTimeType = menu.timeTypes
          .map(tt => tt.id)
          .includes(this.form.timeType.id)
        const containsFoodTypes = menu.foodTypes.some(type => {
          const formFoodTypesIds = this.form.foodTypes.map(ft => ft.id)
          return formFoodTypesIds.includes(type.id)
        })
        return containsTimeType && containsFoodTypes
      })
    },
    itemsAlergens () {
      const alergensObjs = []
      this.form.foods.concat(this.form.drinks, this.form.menus)
        .map(item => item.alergens)
        .forEach(alergensArr => {
          alergensArr.forEach(alergen => {
            alergensObjs.push(alergen)
          })
        })
      const alergens = alergensObjs.map(alergen => alergen.name)
      return [...new Set(alergens)].join(', ')
    },
    weight () {
      let sum = 0
      for (const meal of this.form.foods.concat(this.form.menus)) { sum += +meal.weight }
      return sum.toString()
    },
    volume () {
      let sum = 0
      for (const drink of this.form.drinks.concat(this.form.menus)) { sum += +drink.volume }
      return sum.toString()
    },
    calories () {
      let sum = 0
      for (const item of this.form.foods.concat(this.form.drinks, this.form.menus)) { sum += +item.calories }
      return sum.toString()
    },
    price () {
      let sum = 0
      for (const item of this.form.foods.concat(this.form.drinks, this.form.menus)) { sum += +item.price }
      return sum.toString()
    },
    ...mapGetters({ currentUser: 'user/currentUser' })
  },
  methods: {
    initialize () {
      const tmpDate = new Date()
      const maxDietDate = new Date(this.diet.dateTo)
      this.form.date = tmpDate.getTime() > maxDietDate.getTime()
        ? maxDietDate.toISOString().substr(0, 10)
        : tmpDate.toISOString().substr(0, 10)

      this.$http.get('/admin/alergens')
        .then(response => {
          this.availableAlergens = this.keysToCamelCase(response.data)
            .filter(alergen => alergen.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/admin/food-types')
        .then(response => {
          this.availableFoodTypes = this.keysToCamelCase(response.data)
            .filter(type => type.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/admin/times')
        .then(response => {
          this.timeTypes = this.keysToCamelCase(response.data)
            .filter(time => time.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/admin/foods')
        .then(response => {
          this.availableFoods = this.keysToCamelCase(response.data)
            .filter(food => food.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/admin/drinks')
        .then(response => {
          this.availableDrinks = this.keysToCamelCase(response.data)
            .filter(drink => drink.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/admin/menus')
        .then(response => {
          this.availableMenus = this.keysToCamelCase(response.data)
            .filter(menu => menu.active)
            .map(menu => {
              const unique = []
              for (const alergen of menu.alergens) {
                if (!unique.map(item => item.id).includes(alergen.id)) {
                  unique.push(alergen)
                }
              }
              menu.alergens = unique
              menu.volume = menu.drinks
                .map(drink => drink.volume)
                .join(', ')
              return menu
            })
        })
        .catch(err => {
          console.log(err)
        })
    },
    save () {
      const tmpDate = new Date(this.form.date)
      const options = {
        method: this.dietDayId ? 'put' : 'post',
        url: `/admin/diets/${this.diet.id}/days${this.dietDayId ? '/' + this.dietDayId : ''}`,
        data: this.keysToSnakeCase({
          date: this.form.date,
          foods: this.form.foods,
          drinks: this.form.drinks,
          menus: this.form.menus,
          menu_sequence: this.form.menu_sequence,
          dayOfTheWeek: tmpDate.getDay(),
          timeId: this.form.timeType.id
        })
      }
      this.$http(options)
        .then(response => {
          console.log(this.form.date)
          this.$refs.dataChecked.reset()
          this.$refs.drinksInput.reset()
          this.$refs.foodsInput.reset()
          this.$refs.menusInput.reset()
          this.$emit('date-change', this.form.date)
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created () {
    this.initialize()
    this.$emit('date-change', this.form.date)
  },
  watch: {
    'form.date' () {
      this.$emit('date-change', this.form.date)
    },
    'form.foodTypes': function (foodTypes) {
      // filter drinks
      this.form.drinks = this.form.drinks.filter(drink => {
        const intersection = drink.foodTypes
          .map(FT => FT.id)
          .filter(FTid => foodTypes.map(FT => FT.id).includes(FTid))

        return !!intersection.length
      })

      // filter foods
      this.form.foods = this.form.foods.filter(food => {
        const intersection = food.foodTypes
          .map(FT => FT.id)
          .filter(FTid => foodTypes.map(FT => FT.id).includes(FTid))

        return !!intersection.length
      })

      // filter menus
      this.form.menus = this.form.menus.filter(menu => {
        const intersection = menu.foodTypes
          .map(FT => FT.id)
          .filter(FTid => foodTypes.map(FT => FT.id).includes(FTid))

        return !!intersection.length
      })
    },
    'form.timeTypes': function (timeTypes) {
      // filter drinks
      this.form.drinks = this.form.drinks.filter(drink => {
        const intersection = drink.timeTypes
          .map(TT => TT.id)
          .filter(TTid => timeTypes.map(TT => TT.id).includes(TTid))

        return !!intersection.length
      })

      // filter foods
      this.form.foods = this.form.foods.filter(food => {
        const intersection = food.timeTypes
          .map(TT => TT.id)
          .filter(TTid => timeTypes.map(TT => TT.id).includes(TTid))

        return !!intersection.length
      })

      // filter menus
      this.form.menus = this.form.menus.filter(menu => {
        const intersection = menu.timeTypes
          .map(TT => TT.id)
          .filter(TTid => timeTypes.map(TT => TT.id).includes(TTid))

        return !!intersection.length
      })
    }
  }
}
</script>

<style scoped>

</style>
